/*******************************************************************************

  Project: IMMOPRO360 GmbH
  Author:  What.Digital
  Date:    10.2020

********************************************************************************

  1. Scroll to top
  2. Off canvas menu
  3. EU Cookie
  4. Dropdown Menu
  5. Lightbox for images and videos
  6. Responsive Videos
  7. Scoll Animations Init
  8. Object Fit Images
  9. Contact Form 7 Fix
  10. Accordion
  11. Map
  12. Equal Heights
  13. Footer fix
  14. Parallax
  15. Header
  16. Fix group widths
  17. AJAX Load More
  18. Sliders
  19. Partner Info
  20. Mixitup Team block
  21. Carousel with teasers
  22. Forms
  23. CASA WP

*******************************************************************************/

jQuery( document ).ready(function($) {

/* 1. Scroll to top
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.c-scroll-to-top').addClass('show');
    } else {
      $('.c-scroll-to-top').removeClass('show');
    }
  });

  $('.c-scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

/* 2. Menu
------------------------------------------------------------------------------*/

 // TBD

/* 3. EU Cookie
------------------------------------------------------------------------------*/

  // Variables
  var expires_date = new Date('December 31, 2099 23:59:59');
  var cookie_notice_height = $('.cookie-bar').height();

  // Update variables and padding after screen resize
  $(window).on("debouncedresize", function( event ) {
    cookie_notice_height = $('.cookie-bar').height();
    if(!(Cookies.get('eu-cookie-law-immopro360') == 'accepted' || Cookies.get('eu-cookie-law-immopro360') == 'refused')) {
      $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    }
  });

  // Show cookie notice if it's not configured
  if(Cookies.get('eu-cookie-law-immopro360') == 'accepted' || Cookies.get('eu-cookie-law-immopro360') == 'refused') {
    $('body').removeClass('cookie-bar--not-decided');
  }
  else {
    $('.site-footer .wrap').css('padding-bottom', cookie_notice_height + 'px');
    $('body').addClass('cookie-bar--not-decided');
  }

  // Hide cookie if it's accepted
  $('.js-accept-cookie').on('click', function(e){
    e.preventDefault();
    Cookies.set('eu-cookie-law-immopro360', 'accepted', { expires: expires_date });
    $('body').removeClass('cookie-bar--not-decided');
  });

  // Disable scripts and hide notice
  $('.js-refuse-cookie').on('click', function(e){
    e.preventDefault();
    if(theme_settings.cookie_popup == 1) {
      $.magnificPopup.open({
        items: {
            src: '<div class="white-popup">' + theme_settings.cookie_popup_text + '</div>',
            type: 'inline'
        },
        mainClass: 'mfp-with-fade',
        removalDelay: 160
      });
    }
    else {
      console.log('Tracking scripts and cookies are disabled.');
    }
    Cookies.set('eu-cookie-law-immopro360', 'refused', { expires: expires_date });
    // Opt out functions
    // doOptout();
    $('body').removeClass('cookie-bar--not-decided');
  });

/* 4. Dropdown Menu
------------------------------------------------------------------------------*/
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  var targetElement = document.querySelector('.js-main-menu-mobile-scroll ');


  $('ul.c-hor-menu li').has('ul').addClass('parentLi');
  $('ul.c-hor-menu li ul').addClass('sub-menu');

  $('ul.c-hor-menu--mobile .sub-menu').hide();

  $('.js-menu-toggle').on('click', function(){
    if (mediaQuery.matches) {
      $('.js-main-menu').addClass('c-main-menu--visible js-main-menu--is-active');
    }
    else {
      $('.js-main-menu-mobile').addClass('c-main-menu-mobile--visible js-main-menu-mobile--is-active');
      bodyScrollLock.disableBodyScroll(targetElement, { reserveScrollBarGap: true });
    }
  });

  $('.js-menu-close').on('click', function(){
    $('.js-main-menu').removeClass('c-main-menu--visible js-main-menu--is-active');
    $('.js-main-menu-mobile').removeClass('c-main-menu-mobile--visible js-main-menu-mobile--is-active');
    bodyScrollLock.clearAllBodyScrollLocks();
  });

  $(document).on('mouseup', function(e){
    if($('.js-main-menu').hasClass('js-main-menu--is-active') || $('.js-main-menu-mobile').hasClass('js-main-menu-mobile--is-active')) {
      if (!$('.js-main-menu-content').is(e.target) // if the target of the click isn't the container...
       && $('.js-main-menu-content').has(e.target).length === 0) // ... nor a descendant of the container
      {
        $('.js-main-menu').removeClass('c-main-menu--visible js-main-menu--is-active');
        $('.js-main-menu-mobile').removeClass('c-main-menu-mobile--visible js-main-menu-mobile--is-active');
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    }
  });

  $('ul.c-hor-menu--mobile .parentLi > a').on('click', function(event){
    event.preventDefault();
    $(this).toggleClass('expanded');
    $(this).parent().find('ul.sub-menu').slideToggle();
  });

  // // Hide dropdown after click outside the menu
  // $(document).on('click', function(event) {
  //   if (!$(event.target).closest('.c-hor-menu .menu-item-has-children a').length) {
  //     $('.c-hor-menu .menu-item-has-children').removeClass('opened');
  //   }
  // });

/* 5. Lightbox for images and videos
------------------------------------------------------------------------------*/

  $('a[href$=jpg]:not(.popup-gallery), a[href$=jpeg]:not(.popup-gallery), a[href$=jpe]:not(.popup-gallery), a[href$=png]:not(.popup-gallery), a[href$=gif]:not(.popup-gallery)').magnificPopup({
    type: 'image',
    removalDelay: 500,
    mainClass: 'mfp-with-fade',
    closeOnContentClick: true,
    midClick: true
  });

  $('a.popup-gallery').magnificPopup({
    type: 'image',
    gallery:{
      enabled:true
    },
    removalDelay: 500,
    mainClass: 'mfp-fade',
    closeOnContentClick: true,
    midClick: true
  });

  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-with-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    closeOnBgClick: true,
    iframe: {
			patterns: {
        youtube: {
          index: 'youtube.com/',
          id: function(url) {
                  var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                  if ( !m || !m[1] ) return null;
                  return m[1];
              },
          src: '//www.youtube.com/embed/%id%?autoplay=1'
        },
				youtube_short: {
				  index: 'youtu.be/',
				  id: 'youtu.be/',
				  src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
				}
			}
		}
  });

  $('.js-open-popup').magnificPopup({
		type: 'inline',
		preloader: false,
    closeOnBgClick: true,
    showCloseBtn: false
  });

  $(document).on('click', '.js-close-popup', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});



/* 6. Responsive Videos
/*******************************************************************************/

  fitvids({
    // players: 'iframe[src*="example.com"]'
  });

/* 7. Scoll Animations Init
/*******************************************************************************/

  AOS.init({
    disable: 'mobile',
    once: true
  });

  window.addEventListener('load', AOS.refresh);

  function refreshAOS() {
    AOS.refresh();
  }

  $('img').on('load', _.throttle(refreshAOS, 1000));

/* 8. Object Fit Images
/*******************************************************************************/

  objectFitImages();

/* 9. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

/* 10. Accordion
/*******************************************************************************/

  // Hide all accordions
  var allPanels = $('.accordion dd').hide();
  var allTitles = $('.accordion dt');

  $('.accordion dt > a').click(function(e) {
  e.preventDefault();
  var $this = $(this);
  var $title = $this.parent();
  var $target =  $this.parent().next();

  if(!$target.hasClass('accordion__text--active')){
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
    $target.addClass('accordion__text--active').slideDown();
    $title.addClass('accordion__subtitle--active');
  }
  else {
    allPanels.removeClass('accordion__text--active').slideUp();
    allTitles.removeClass('accordion__subtitle--active');
  }
  return false;
  });

/* 11. Map
/*******************************************************************************/

  $.each($('.dyn-map'), function(){

    var lat = $(this).data('lat');
    var long = $(this).data('long');
    var zoom = $(this).data('zoom');

    L.Icon.Default.imagePath = theme_settings.template_dir + '/assets/img/leaflet/';
    var mymap = new L.map($(this)[0], {
    scrollWheelZoom: false
    }).setView([lat, long], 16);

    // create custom icon
    var pinIcon = L.icon({
        iconUrl: theme_settings.template_dir + '/assets/img/leaflet/pin.svg',
        shadowUrl:  theme_settings.template_dir + '/assets/img/leaflet/marker-shadow.png',
        iconSize: [40, 50], // size of the icon
        iconAnchor:   [16, 50],
        shadowAnchor: [10, 39],
        popupAnchor:  [5, -48]
    });

    // Open Street Map - Wikimedia
    L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
        attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
        maxZoom: zoom
    }).addTo(mymap);

    if($(this).data('popup')) {
      L.marker([lat, long], {icon: pinIcon}).addTo(mymap)
      .bindPopup($(this).data('popup'))
      .openPopup();
    }

    // Open Street Map
    /*
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Open Street Map - Black and White
    /*
    L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Mapbox - remember to change accessToken
    /*
    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: zoom,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoiYWRhbXBpbGNoIiwiYSI6ImNqbTY0aGlzeTB0eTEza280dGVpcjVnemMifQ.zZjr5GSWWpe4lYGBjvuz1A'
    }).addTo(mymap);
    */

    mymap.on('click', function() {
    if (mymap.scrollWheelZoom.enabled()) {
      mymap.scrollWheelZoom.disable();
      }
      else {
      mymap.scrollWheelZoom.enable();
      }
    });

  });

/* 12. Equal Heights
------------------------------------------------------------------------------*/

  // Example:
  // $('.something').matchHeight();
  //$('.latest-news__cnt').matchHeight();

  // Match Height compatibility with Lazy Load techniques
  function refreshMatchHeight() {
    $.fn.matchHeight._update();
  }
  $('img').on('load', _.throttle(refreshMatchHeight, 1000));

/* 13. Footer fix
------------------------------------------------------------------------------*/

  function fixFooter() {
    if($('body').outerHeight() < $(window).outerHeight()) {
      var footerHeight = $('.js-footer').outerHeight();
      var bodyHeight = $('body').outerHeight();
      var windowHeight = $(window).outerHeight();
      var contentHeight = bodyHeight - footerHeight;
      $('.js-footer').css('min-height', windowHeight - contentHeight + 'px');
    }
  }

  fixFooter();
  $(window).on("debouncedresize", function( event ) { fixFooter(); });

/* 14. Parallax
------------------------------------------------------------------------------*/

  window.onload = function() {
    lax.setup(); // init

    function updateLax(){
      lax.update(window.scrollY);
      window.requestAnimationFrame(updateLax);
    }

    window.requestAnimationFrame(updateLax);
  };

/* 15. Header
------------------------------------------------------------------------------*/
  /*
  // Function which controls header status according to the distance from top
  function setHeaderStatus(scroll){
    if (scroll >= 1) { $('.js-header').addClass('bg-white'); }
    else {
      if(!($('body').hasClass('hc-nav-open'))) {
        $('.js-header').removeClass('bg-white');
      }
    }
  }

  // Set status on load
  setHeaderStatus($(window).scrollTop());

  // Set status during the scroll
  $(window).scroll(function() {
    setHeaderStatus($(window).scrollTop());
  });
  */
/* 16. Fix group widths
------------------------------------------------------------------------------*/

  $('.wp-block-group').each(function( index ) {
    if($(this).hasClass('alignfull')) {
      $(this).wrap( '<div class="wp-block-group-wrap alignfull"></div>' );
    }
    else if($(this).hasClass('alignwide')) {
      $(this).wrap( '<div class="wp-block-group-wrap alignwide"></div>' );
    }
    else {
      $(this).wrap( '<div class="wp-block-group-wrap"></div>' );
    }
  });

/* 17. AJAX Load More
------------------------------------------------------------------------------*/

  $('.js-load-more').click(function(){
    var button = $(this);
    var content_place = $(this).parent();
    var data = {
      'action': 'ajax_load_more',
      'query': theme_settings.posts,
      'page' : theme_settings.current_page
    };

    if (!(button.hasClass('c-btn--post-loading-loader') || button.hasClass('c-btn--post-no-more-posts'))) {

      $.ajax({
        url : theme_settings.ajaxurl,
        data : data,
        type : 'POST',
        beforeSend : function ( xhr ) {
          button.addClass('c-btn--post-loading-loader').find('span').html(theme_settings.loading);
        },
        success : function( data ){
          var tempScrollTop = $(window).scrollTop();
          if( data.length ) {
            button.removeClass('c-btn--post-loading-loader').find('span').html(theme_settings.loadmore);
            $(data).insertBefore(content_place);
            theme_settings.current_page++;

            if ( theme_settings.current_page == theme_settings.max_page )
              button.removeClass('c-btn--post-loading-loader').addClass('c-btn--post-no-more-posts').find('span').html(theme_settings.noposts);
          } else {
            button.removeClass('c-btn--post-loading-loader').addClass('c-btn--post-no-more-posts').find('span').html(theme_settings.noposts);
          }
          $(window).scrollTop(tempScrollTop);
        }
      });
    }
  });


/* 18. Sliders
------------------------------------------------------------------------------*/

$('.image-carousel__wrapper').slick({
  infinite: true,
  arrows: true,
  dots: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.image-carousel__wrapper-caption',
});


$('.image-carousel__wrapper-caption').slick({
  infinite: true,
  arrows: false,
  dots: false,
  fade: true,
  asNavFor: '.image-carousel__wrapper',
});

$('.js-offer-carousel').slick({
  fade: true,
  arrows: false,
  dots: true
});

/* 19. Partner Info
------------------------------------------------------------------------------*/

var allPanels = $('.partner-info__cnt').hide();
var allTitles = $('.partner-info__btn');

$('.partner-info__btn').click(function(e) {
e.preventDefault();
var $this = $(this);
var $title = $this;
var $target =  $this.parent().next();

if(!$target.hasClass('partner-info__cnt--active')){
  // allPanels.removeClass('partner-info__cnt--active').slideUp();
  // allTitles.removeClass('partner-info__btn--active');
  $target.addClass('partner-info__cnt--active').slideDown();
  $title.addClass('partner-info__btn--active');
}
else {
  $target.removeClass('partner-info__cnt--active').slideUp();
  $title.removeClass('partner-info__btn--active');
}
return false;
});

var allPanels = $('.team__cnt').hide();
var allTitles = $('.team__btn');

$('.team--img').click(function(e) {
  e.preventDefault();
  var $this = $(this);
  var $title = $this.parent().find('.team__btn');
  var $target =  $this.parent().find('.team__cnt');

  if(!$target.hasClass('team__cnt--active')){
    $target.addClass('team__cnt--active').slideDown();
    $title.addClass('team__btn--active');
  }
  else {
    $target.removeClass('team__cnt--active').slideUp();
    $title.removeClass('team__btn--active');
  }
  return false;
});

$('.team__btn').click(function(e) {
  e.preventDefault();
  var $this = $(this);
  var $title = $this;
  var $target =  $this.parent().next();

  if(!$target.hasClass('team__cnt--active')){
    $target.addClass('team__cnt--active').slideDown();
    $title.addClass('team__btn--active');
  }
  else {
    $target.removeClass('team__cnt--active').slideUp();
    $title.removeClass('team__btn--active');
  }
  return false;
});

/* 20. Mixitup Team block
/*******************************************************************************/

  if($('.js-team-members').length > 0) {
    var first_department =  $('.js-team-members button').first().data('filter');
    var mixer = mixitup('.js-team-members-container', {
      load: {
        filter: first_department
      },
    });
  }

/* 21. Carousel with teasers
/*******************************************************************************/

  $('.js-teasers-carousel').slick({
    infinite: true,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    fade: true
  });

/* 22. Forms
------------------------------------------------------------------------------*/

  $('.forminator-select').each(function(){
    $(this).parent().addClass('hide-label');
  });

  $('.forminator-input:not(.forminator-field--phone), .forminator-textarea').each(function(){
    $(this).parent().addClass('floating-label');
  });

  $('.forminator-button').each(function(){
    $(this).addClass('c-form-btn');
  });

  $('.form-wrap .form-input, .form-wrap .form-textarea, .forminator-field .forminator-input, .forminator-field .forminator-textarea, .floating-label .form-control')
    .on('focus', function(){
      $(this).closest('.forminator-field').addClass('forminator-field--is-active');
      $(this).closest('.form-group').addClass('forminator-field--is-active');
    })
    .on('blur', function(){
      if(!$(this).val()) {
        $(this).closest('.forminator-field').removeClass('forminator-field--is-active');
        $(this).closest('.form-group').removeClass('forminator-field--is-active');
      }
    });

  $('.chosen-select').select2();

// 23. CASA WP

  var propertiesSlider = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    speed: 600,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  // Tabs
  if($('.js-properties-tabs').length > 0) {
    var url = new URL(window.location.href);
    var searchParams = new URLSearchParams(url.search);
    if(searchParams.has('availabilities') && searchParams.get('availabilities') == 'reference') {
      $('.js-properties-reference').removeClass('bg-white').addClass('text-white bg-main hover:no-underline hover:text-white');
    }
    else {
      $('.js-properties-all').removeClass('bg-white').addClass('text-white bg-main hover:no-underline hover:text-white');
    }
  }

  $('table.table').wrap('<div class="overflow-x-auto"></div>');

}); // end of jQuery code
